//请自行添加语言资源
const shipGroup = {

  schOrderNo:'子订单编号',
  orderTypeName:'订单类型',
  itrCode: 'ITR',
  ediSoCode: 'SO',
  schOrderStatusName: '订单状态',
  customerCode:'租赁方',
  customerName:'租赁方名称',
  businessType:'业务板块',
  itrYardCode:'堆场',
  consigneeCode:'收货方',
  carrierNo:'承运商编号',
  planShipTime: '预计发货日',
  planArriveTime:'预计到货日',
  actDispatchTime:'实际发货时间',
  actArriveTime:'实际到货时间',
  expectedDeliveryDate:'客户要求到货日期',
  epodUploadTime:'EPOD回传时间',
  skuCode:'SKU',
  skuQty:'数量',
  vendorCodeForYard: '堆场VENDOR',
  poCodeForYard:'堆场PO',
  vendorCodeForCarrier:'物流VENDOR',
  poCodeForCarrier:'物流PO',
  vendorCodeForSeaTransport:'海运VENDOR',
  poCodeForSeaTransport:'海运PO',
  createTime:'订单创建日期',
  boxConditionName:  '箱况',
  msg:{

  }
};
export default shipGroup



// WEBPACK FOOTER //
// ./src/page/report/shipGroup/lang/shipGroup.zh.js